function defineImpact(weight) {
  let foundImpact = 'Low';
  if (parseInt(weight) >= 5) foundImpact = 'Medium';
  if (parseInt(weight) >= 10) foundImpact = 'High';
  return foundImpact;
}

export default {
  defineImpact,
};
